import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Chip,
  Tooltip,
  Zoom,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getMyStudents, resetAllActions } from "../../State/Instructor/Action";
import AppPagination from "../Tools/AppPagination";
import SchoolIcon from "@mui/icons-material/School";
import VerifiedIcon from "@mui/icons-material/Verified";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ClassIcon from "@mui/icons-material/Class";
import PersonIcon from "@mui/icons-material/Person";
import { motion } from "framer-motion";

const MyStudents = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);

  const students = useSelector(
    (state) => state.instructor?.myStudents?.data?.learners || []
  );
  const totalPages = useSelector(
    (state) => state.instructor?.myStudents?.data?.totalPages || 0
  );

  useEffect(() => {
    dispatch(resetAllActions());
    dispatch(getMyStudents(page));
  }, [dispatch, page]);

  return (
    <Box
      sx={{
        background: "linear-gradient(to right, #e3f2fd, #fce4ec)",
        minHeight: "100vh",
        py: 6,
        px: 2,
      }}
    >
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#1565c0" }}
      >
        👨‍🎓 My Students
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {students.map((student, index) => (
          <Grid item xs={12} md={10} key={student.learnerId}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#ffffffee",
                  boxShadow: 3,
                  borderRadius: 3,
                  p: 2,
                }}
              >
                <Avatar
                  src={student.profilePictureUrl}
                  alt={student.fullName}
                  sx={{ width: 80, height: 80, mr: 3 }}
                />
                <CardContent sx={{ flex: 1 }}>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    <PersonIcon sx={{ mr: 1 }} /> {student.fullName}
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <AccountCircleIcon sx={{ mr: 1 }} /> @{student.username}
                  </Typography>

                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <ClassIcon sx={{ mr: 1 }} color="action" />
                    Course: <strong>{student.courseName}</strong>
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{ mt: 0.5, color: "text.secondary" }}
                  >
                    <SchoolIcon sx={{ mr: 1 }} fontSize="small" />
                    Start:{" "}
                    <strong>
                      {new Date(student.courseStartDate).toLocaleDateString()}
                    </strong>{" "}
                    | End:{" "}
                    <strong>
                      {new Date(student.courseEndDate).toLocaleDateString()}
                    </strong>
                  </Typography>

                  <Chip
                    label={
                      student.subscriptionActive
                        ? "Active Subscription"
                        : "Inactive"
                    }
                    color={student.subscriptionActive ? "success" : "error"}
                    icon={<VerifiedIcon />}
                    size="small"
                    sx={{ mt: 1 }}
                  />
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      <Box display="flex" justifyContent="center" mt={5}>
        <AppPagination setPage={setPage} totalPages={totalPages} />
      </Box>
    </Box>
  );
};

export default MyStudents;
